<elcia-card [title]="'invoice.step.send' | translate">
  <div class="flex flex-col gap-4">

    <!-- Mail template selector -->
    <div class="flex gap-4">
      <div class="flex-1">
        <elcia-dropdown
          (selectionChange)="onTemplateSelected($event)"
          [control]="sendForm.controls.templateId"
          [items]="mailTemplates()"
          [label]="'invoice.send.template' | translate"
        />
      </div>
      <div class="flex-1"></div>
    </div>

    <!-- To -->
    <elcia-email-autocomplete
      [control]="sendForm.controls.to"
      [label]="'invoice.send.to' | translate"
      [suggestions]="emailSuggestions()"
    />

    <!-- Cc and Bcc side by side -->
    <div class="flex gap-4">
      <elcia-email-autocomplete
        [control]="sendForm.controls.cc"
        [label]="'invoice.send.cc' | translate"
        [suggestions]="emailSuggestions()"
        class="flex-1"
      />
      <elcia-email-autocomplete
        [control]="sendForm.controls.bcc"
        [label]="'invoice.send.bcc' | translate"
        [suggestions]="emailSuggestions()"
        class="flex-1"
      />
    </div>

    <!-- Subject -->
    <elcia-text-input
      [control]="sendForm.controls.object"
      [label]="'invoice.send.object' | translate"
    />

    <!-- Rich text editor -->
    <elcia-editor [control]="sendForm.controls.content"/>

    <!-- Extra attachments (the invoice PDF is generated later, once a number is assigned) -->
    <elcia-document-uploader
      (onFilesSelected)="addAttachments($event)"
      (onRemovePendingFile)="removeAttachment($event)"
      [hint]="'invoice.send.extra-attachments-hint'"
      [label]="'invoice.send.extra-attachments'"
      [pendingFiles]="sendForm.controls.attachments.value"
    />

    <!-- Pro forma toggle -->
    <div class="flex items-center gap-3">
      <p-toggle-switch [formControl]="sendForm.controls.isProForma"/>
      <span class="text-sm text-surface-700">
        {{ 'invoice.send.pro-forma' | translate }}
      </span>
    </div>

  </div>
</elcia-card>
